import { axiosInstanceWebsite } from "../instance";

export const membershipAxios = async () => {
    const response = await axiosInstanceWebsite.get(`/subscription/user-memberships/user/active`);
    return response.data;
};

export const membershipStatsAxios = async () => {
    const response = await axiosInstanceWebsite.get(`/subscription/user-memberships/user/stats`);
    return response.data;
};

export const getTypesPlans = async () => {
    const response = await axiosInstanceWebsite.get(`/subscription/membership`);
    return response.data;
};

export const getCancelStatus = async () => {
    const response = await axiosInstanceWebsite.get(`/subscription/user-memberships/cancel/status`);
    return response.data;
};

export const cancelMembership = async (reason: string) => {
    const response = await axiosInstanceWebsite.put(`/subscription/user-memberships/cancel`, {
        reason: reason
    });
    return response.data;
};

